module.exports = __webpack_public_path__ + "fonts/HMpangram-Bold.cc5d7e44.ttf";